// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2-RD1","list":"PatternAutocomplete_list__1D_IB"};